module.exports = __webpack_public_path__ + "media/images/niq-duplicate-07fa36a29d21ee63d9396d5dca4bb71b.svg";